/* eslint-disable */
import * as ChannelTalk from '@channel.io/channel-web-sdk-loader';
import { IS_CLIENT } from '@repo/common-utils';
import { BootOption } from '@channel.io/channel-web-sdk-loader';

export class ChannelService {
  private _isScriptLoaded = false;
  private _isChannelTalkInit = false;

  constructor() {
    if (IS_CLIENT) {
      ChannelTalk.loadScript();
      this._isScriptLoaded = true;
    }
  }

  get isChannelTalkInit() {
    return this._isChannelTalkInit;
  }

  boot(settings: BootOption) {
    if (this._isScriptLoaded) {
      ChannelTalk.boot(settings);
      this._isChannelTalkInit = true;
    }
  }

  showChannelButton() {
    if (this._isScriptLoaded) {
      ChannelTalk.showChannelButton();
    }
  }

  hideChannelButton() {
    if (this._isScriptLoaded) {
      ChannelTalk.hideChannelButton();
    }
  }

  shutdown() {
    if (this._isScriptLoaded) {
      ChannelTalk.shutdown();
      this._isChannelTalkInit = false;
    }
  }

  setPage(page: string) {
    if (this._isScriptLoaded) {
      ChannelTalk.setPage(page);
    }
  }

  updateUser(userInfo: ChannelTalk.UpdateUserInfo, callback?: ChannelTalk.Callback) {
    if (this._isScriptLoaded) {
      ChannelTalk.updateUser(userInfo, callback);
    }
  }

  track(eventName: string, eventProperty?: ChannelTalk.EventProperty) {
    if (this._isScriptLoaded) {
      ChannelTalk.track(eventName, eventProperty);
    }
  }

  openChat(chatId?: string | number, message?: string) {
    if (this._isScriptLoaded) {
      ChannelTalk.openChat(chatId, message);
    }
  }

  openSupportBot(botId: string) {
    if (this._isScriptLoaded) {
      ChannelTalk.openWorkflow(botId);
    }
  }

  showMessenger() {
    if (this._isScriptLoaded) {
      ChannelTalk.showMessenger();
    }
  }

  hideMessenger() {
    if (this._isScriptLoaded) {
      ChannelTalk.hideMessenger();
    }
  }
}

export const channelService = new ChannelService();
